module.exports = __webpack_public_path__ + "img/cash-icon.7e462397.png";